<template>
  <b-modal
    :visible="visible"
    centered
    modal-class="status-update-modal sts_purchaser_nodal_cn iu-modal"
    no-close-on-backdrop
    size="sm"
    title="Edit Purchaser Details"
    @change="val => $emit('update:visible', val)"
  >
    <b-form-group
      label="Name*"
      label-for="h-pd-name"
    >
      <b-input-group class="np_singpass_group">
        <b-form-input
          id="h-pd-name"
          v-model="customerNameValue"
          :disabled="nameLocked"
          class="text-uppercase"
          placeholder="Name"
        />
        <b-input-group-append
          v-if="singpass"
          is-text
          class="singpass-block_spt"
        >
          <b-badge
            variant="secondary"
            class="singpass-badge"
          >
            via Singpass
          </b-badge>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-form-group
      label="NRIC*"
      label-for="h-pd-nric"
    >
      <b-form-input
        id="h-pd-nric"
        v-model="customerNricValue"
        :disabled="nricLocked"
        class="text-uppercase"
        placeholder="NRIC"
        autocomplete="off"
        @input="onNricInput"
        @focusout="hideResultsDelayed"
      />
      <div
        v-show="showSearchResults"
        class="search-results mt-50 z-index-99"
      >
        <b-list-group
          v-if="searchResults.length"
          flush
        >
          <b-list-group-item
            v-for="customer in searchResults"
            :key="customer._id"
            class="cursor-pointer"
            @click="selectCustomer(customer)"
          >
            <span class="text-primary">{{ customer.name }}</span>
            <br>
            <small class="text-muted">{{ customer.nric }} {{ customer.perEmail ? `/ ${customer.perEmail}` : '' }}</small>
          </b-list-group-item>
        </b-list-group>
        <b-list-group v-else-if="customerNricValue">
          <b-list-group-item>
            No result found.
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-form-group>

    <b-form-group
      label="Date of Birth*"
      label-for="h-pd-dob"
      class="calendar_sp_icon"
    >
      <flat-pickr
        id="h-pd-dob"
        v-model="customerDobValue"
        class="form-control"
        placeholder="Date of Birth"
        :disabled="dobLocked"
        :config="flatPickrConfig"
      />
      <feather-icon
        icon="CalendarIcon"
        class="calendar-icon"
        size="16"
      />
    </b-form-group>

    <b-form-group
      label="Sex*"
      label-for="h-pd-sex"
    >
      <v-select
        id="h-pd-sex"
        v-model="customerSexValue"
        label="title"
        :options="genderOptions"
        :reduce="title => title.code"
        :clearable="false"
        :disabled="sexLocked"
        class="text-uppercase"
      />
    </b-form-group>

    <b-form-group
      label="Race*"
      label-for="h-pd-race"
    >
      <v-select
        id="h-pd-race"
        v-model="customerRaceValue"
        label="title"
        :options="raceOptions"
        :reduce="title => title.code"
        :clearable="false"
        class="text-uppercase"
      />
    </b-form-group>

    <b-form-group
      label="Nationality*"
      label-for="h-pd-nationality"
    >
      <v-select
        id="h-pd-nationality"
        v-model="customerNationalityValue"
        label="title"
        :options="nationalityOptions"
        :reduce="title => title.code"
        :clearable="false"
        :disabled="nationalityLocked"
        class="text-uppercase"
      />
    </b-form-group>

    <b-form-group
      label="Mobile No.*"
      label-for="h-pd-contact"
    >
      <b-form-input
        id="h-pd-contact"
        v-model="customerContactValue"
        placeholder="+65 Enter 8-digits number"
      />
    </b-form-group>

    <b-form-group
      label="Email Address*"
      label-for="h-pd-email"
    >
      <b-form-input
        id="h-pd-email"
        v-model="customerEmailValue"
        type="email"
        placeholder="Email Address"
        :readonly="emailLocked"
        @focus="onEmailFieldFocus"
      />
    </b-form-group>

    <!-- <h5 class="mb-75 mt-2">
      Permanent Address
    </h5> -->
    <b-form-group
      label="Permanent Address"
      label-for="h-pd-perAdd1"
    >
      <b-form-input
        id="h-pd-perAdd1"
        v-model="perAddress1Value"
        :disabled="permAddressLocked"
        class="text-uppercase"
        placeholder="Address Line 1"
      />
    </b-form-group>
    <b-form-group
      label-for="h-pd-perAdd2"
    >
      <b-form-input
        id="h-pd-perAdd2"
        v-model="perAddress2Value"
        :disabled="permAddressLocked"
        class="text-uppercase"
        placeholder="Address Line 2"
      />
    </b-form-group>
    <b-form-group
      label-for="h-pd-perCountry"
    >
      <v-select
        id="h-pd-perCountry"
        v-model="perCountryValue"
        label="title"
        :options="countryOptions"
        :reduce="title => title.code"
        :clearable="false"
        :disabled="permAddressLocked"
        class="text-uppercase"
      />
    </b-form-group>
    <b-form-group
      label-for="h-pd-perPostcode"
    >
      <b-form-input
        id="h-pd-perPostcode"
        v-model="perPostcodeValue"
        :disabled="permAddressLocked"
        placeholder="Postal Code"
      />
    </b-form-group>

    <!-- <h5 class="mb-75 mt-2">
      Correspondence Address
    </h5> -->
    <b-form-group
      label="Correspondence Address"
      label-for="h-pd-corAdd1"
    >
      <b-form-input
        id="h-pd-corAdd1"
        v-model="corAddress1Value"
        class="text-uppercase"
        placeholder="Address Line 1"
      />
    </b-form-group>
    <b-form-group
      label-for="h-pd-corAdd2"
    >
      <b-form-input
        id="h-pd-corAdd2"
        v-model="corAddress2Value"
        class="text-uppercase"
        placeholder="Address Line 2"
      />
    </b-form-group>
    <b-form-group
      label-for="h-pd-corCountry"
    >
      <v-select
        id="h-pd-corCountry"
        v-model="corCountryValue"
        label="title"
        :options="countryOptions"
        :reduce="title => title.code"
        :clearable="false"
        class="text-uppercase"
      />
    </b-form-group>
    <b-form-group
      label-for="h-pd-corPostcode"
    >
      <b-form-input
        id="h-pd-corPostcode"
        v-model="corPostcodeValue"
        placeholder="Postal Code"
      />
    </b-form-group>

    <template #modal-footer="{}">
      <b-button
        variant="flat-primary"
        :disabled="saving"
        @click="$emit('update:visible', false)"
      >
        Cancel
      </b-button>
      <b-button
        variant="success-custom"
        type="button"
        :disabled="saving"
        @click="save"
      >
        <feather-icon
          icon="SaveIcon"
          class="mr-50"
          size="16"
        />
        <span class="align-middle">Save Changes</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BButton, BBadge, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BBadge,
    BListGroup,
    BListGroupItem,
    vSelect,
    flatPickr,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    // Whether the purchaser's data was captured via Singpass at submission time - drives which
    // fields below stay locked (Name/NRIC/DOB/Sex/Nationality/Permanent Address). Race, Mobile No,
    // Email and Correspondence Address stay editable regardless.
    singpass: {
      type: Boolean,
      default: false,
    },
    // emailVerified of the currently-linked Customer - independent of singpass, locks Email
    // (readonly, not disabled) the same way the file-transfer purchaser form does.
    emailVerified: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: String,
      default: null,
    },
    customerName: {
      type: String,
      default: '',
    },
    customerNric: {
      type: String,
      default: '',
    },
    customerDob: {
      type: String,
      default: null,
    },
    customerSex: {
      type: String,
      default: '',
    },
    customerRace: {
      type: String,
      default: '',
    },
    customerNationality: {
      type: String,
      default: '',
    },
    customerContact: {
      type: String,
      default: '',
    },
    customerEmail: {
      type: String,
      default: '',
    },
    perAddress1: {
      type: String,
      default: '',
    },
    perAddress2: {
      type: String,
      default: '',
    },
    perPostcode: {
      type: String,
      default: '',
    },
    perCountry: {
      type: String,
      default: '',
    },
    corAddress1: {
      type: String,
      default: '',
    },
    corAddress2: {
      type: String,
      default: '',
    },
    corPostcode: {
      type: String,
      default: '',
    },
    corCountry: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedCustomerId: this.customerId,
      resolvedEmailVerified: this.emailVerified,
      customerNameValue: this.customerName,
      customerNricValue: this.customerNric,
      customerDobValue: this.customerDob,
      customerSexValue: this.customerSex,
      customerRaceValue: this.customerRace,
      customerNationalityValue: this.customerNationality,
      customerContactValue: this.customerContact,
      customerEmailValue: this.customerEmail,
      perAddress1Value: this.perAddress1,
      perAddress2Value: this.perAddress2,
      perPostcodeValue: this.perPostcode,
      perCountryValue: this.perCountry,
      corAddress1Value: this.corAddress1,
      corAddress2Value: this.corAddress2,
      corPostcodeValue: this.corPostcode,
      corCountryValue: this.corCountry,
      searchResults: [],
      showSearchResults: false,
      searchTimer: null,
      flatPickrConfig: {
        dateFormat: 'd/m/Y',
        disableMobile: true,
      },
      genderOptions: [
        { title: 'MALE', code: 'MALE' },
        { title: 'FEMALE', code: 'FEMALE' },
        { title: 'N/A', code: 'N/A' },
      ],
      raceOptions: [
        { title: 'CHINESE', code: 'CHINESE' },
        { title: 'INDIAN', code: 'INDIAN' },
        { title: 'N/A', code: 'N/A' },
        { title: 'OTHERS', code: 'OTHERS' },
      ],
      nationalityOptions: [
        { title: 'SINGAPOREAN', code: 'SINGAPOREAN' },
        { title: 'MALAYSIAN', code: 'MALAYSIAN' },
        { title: 'OTHERS', code: 'OTHERS' },
      ],
      countryOptions: [
        { title: 'SINGAPORE', code: 'SINGAPORE' },
        { title: 'MALAYSIA', code: 'MALAYSIA' },
        { title: 'OTHERS', code: 'OTHERS' },
      ],
    }
  },
  computed: {
    // Singpass-sourced fields can't be edited by the admin - only Race, Mobile No, Email and
    // Correspondence Address stay open regardless of how the data was originally captured.
    nameLocked() {
      return this.singpass
    },
    nricLocked() {
      return this.singpass
    },
    dobLocked() {
      return this.singpass
    },
    sexLocked() {
      return this.singpass
    },
    nationalityLocked() {
      return this.singpass
    },
    permAddressLocked() {
      return this.singpass
    },
    emailLocked() {
      return this.resolvedEmailVerified === true
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.selectedCustomerId = this.customerId
        this.resolvedEmailVerified = this.emailVerified
        this.customerNameValue = this.customerName
        this.customerNricValue = this.customerNric
        this.customerDobValue = this.customerDob
        this.customerSexValue = this.customerSex
        this.customerRaceValue = this.customerRace
        this.customerNationalityValue = this.customerNationality
        this.customerContactValue = this.customerContact
        this.customerEmailValue = this.customerEmail
        this.perAddress1Value = this.perAddress1
        this.perAddress2Value = this.perAddress2
        this.perPostcodeValue = this.perPostcode
        this.perCountryValue = this.perCountry
        this.corAddress1Value = this.corAddress1
        this.corAddress2Value = this.corAddress2
        this.corPostcodeValue = this.corPostcode
        this.corCountryValue = this.corCountry
        this.searchResults = []
        this.showSearchResults = false
      }
    },
  },
  methods: {
    onNricInput() {
      // Locked (singpass) NRIC never triggers a lookup - the field can't be edited anyway.
      if (this.nricLocked) return
      this.selectedCustomerId = null
      if (this.searchTimer) clearTimeout(this.searchTimer)
      if (!this.customerNricValue || this.customerNricValue.length < 2) {
        this.searchResults = []
        this.showSearchResults = false
        return
      }
      this.searchTimer = setTimeout(() => {
        axios.get('appointment/bookings/respond-with/customers/nric', { params: { search: this.customerNricValue } })
          .then(response => {
            this.searchResults = response.data.customers || []
            this.showSearchResults = true
          })
      }, 1000)
    },
    hideResultsDelayed() {
      setTimeout(() => {
        this.showSearchResults = false
      }, 200)
    },
    // Prefill only - matched fields stay editable afterwards, unlike the "Exercised For" lookup
    // elsewhere in the app which locks fields once a match is picked.
    selectCustomer(customer) {
      this.selectedCustomerId = customer._id
      this.resolvedEmailVerified = !!customer.emailVerified
      this.customerNameValue = customer.name
      this.customerNricValue = customer.nric
      this.customerDobValue = customer.dob ? this.dateFormat(customer.dob) : null
      this.customerSexValue = customer.sex
      this.customerRaceValue = customer.race
      this.customerNationalityValue = customer.nationality
      this.customerContactValue = customer.perContact
      this.customerEmailValue = customer.perEmail
      this.perAddress1Value = customer.perAddress1
      this.perAddress2Value = customer.perAddress2
      this.perPostcodeValue = customer.perPostcode
      this.perCountryValue = customer.perCountry
      this.corAddress1Value = customer.corAddress1
      this.corAddress2Value = customer.corAddress2
      this.corPostcodeValue = customer.corPostcode
      this.corCountryValue = customer.corCountry
      this.showSearchResults = false
    },
    onEmailFieldFocus(event) {
      if (!this.emailLocked) return
      event.target.blur()
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'This purchaser\'s email is verified on an existing account and can\'t be edited here.',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    },
    save() {
      this.$emit('save', {
        customerId: this.selectedCustomerId,
        customerName: this.customerNameValue,
        customerNric: this.customerNricValue,
        customerDob: this.customerDobValue,
        customerSex: this.customerSexValue,
        customerRace: this.customerRaceValue,
        customerNationality: this.customerNationalityValue,
        customerContact: this.customerContactValue,
        customerEmail: this.customerEmailValue,
        perAddress1: this.perAddress1Value,
        perAddress2: this.perAddress2Value,
        perPostcode: this.perPostcodeValue,
        perCountry: this.perCountryValue,
        corAddress1: this.corAddress1Value,
        corAddress2: this.corAddress2Value,
        corPostcode: this.corPostcodeValue,
        corCountry: this.corCountryValue,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.search-results {
  position: absolute;
  background: #fff;
  border: 1px solid #e0e5eb;
  border-radius: 6px;
  width: 100%;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.singpass-badge {
  background-color: transparent !important;
  color: #6e6b7b !important;
  border: 1px solid #d8d6de;
}
</style>
